// Copyright (c) Docugami, Inc. All rights reserved.
import styled, { css } from 'styled-components';
import { aaTextColor, appContentColor, greyText } from '../shell/presentation/AppStyles';

export const userFontFamily = 'Lato';
export const dgFontFamily = 'Montserrat';
export const dgTagFontFamily = 'Roboto Condensed';

export const primaryFontExpanded = "'" + userFontFamily + "', sans-serif";
export const primaryContentFont = "'" + dgFontFamily + "', sans-serif";
export const tagFont = "'" + dgTagFontFamily + "', sans-serif";

export const LargeTitle = styled.span`
    font-family: ${userFontFamily};
    font-size: 40px;
    font-weight: 900;
`;

export const UserTitle = styled.span`
    font-family: ${dgFontFamily};
    font-size: 20px;
    font-weight: 100;
`;

export const UserContent = styled.span`
    font-family: ${userFontFamily};
    font-weight: 700;
    font-size: 18px;
`;

export const UserInfo = styled.span`
    font-family: ${dgFontFamily};
    font-size: 18px;
    font-weight: 500;
    color: ${aaTextColor};
`;

export const RegularButton = styled.span`
    font-family: ${dgFontFamily};
    font-size: 18px;
    font-weight: 500;
    color: ${appContentColor};
`;

export const SmallButton = styled.span`
    font-family: ${dgFontFamily};
    font-size: 16px;
    font-weight: 500;
    color: ${appContentColor};
`;

export const LargeUI = styled.span`
    font-family: ${dgFontFamily};
    font-size: 24px;
    font-weight: 500;
    color: ${appContentColor};
`;

export const LargeUIBold = styled.span`
    font-family: ${dgFontFamily};
    font-size: 24px;
    font-weight: 700;
    color: ${appContentColor};
`;

export const SectionalUI = styled.span`
    font-family: ${dgFontFamily};
    font-size: 18px;
    font-weight: 300;
    color: ${aaTextColor};
`;

export const SectionLabel = styled.div`
    font-family: ${dgFontFamily};
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
`

export const LargeContent = styled.span`
    font-family: ${dgFontFamily};
    font-size: 40px;
    font-weight: 300;
    color: ${appContentColor};
`;

export const SmallContent = styled.span`
    font-family: ${dgFontFamily};
    font-size: 24px;
    font-weight: 400;
    color: ${appContentColor};
`;

export const LargeHeading = styled.span`
    font-family: ${dgFontFamily};
    font-size: 40px;
    font-weight: 800;
`;

export const SmallButtonLabel = styled.span`
    font-family: ${dgFontFamily};
    font-size: 10px;
    font-weight: 500;
    color: ${appContentColor};
`;

export const TagText = styled.span`
    font-family: ${dgTagFontFamily};
    font-weight: 700;
    font-size: 16px;
    color: ${appContentColor};
`;

export const ChunkItemHeaderText = styled.span`
    font-family: ${dgTagFontFamily};
    font-weight: 700;
    font-size: 18px;
    color: ${appContentColor};
`;

export const ChunkItemBodyText = styled.span<{ highlightColor?: string }>`
    font-family: ${userFontFamily};
    font-weight: 400;
    font-size: 14px;
    color: 'black';
    border-radius: 2px;
    background: ${props => props.highlightColor ?? props.highlightColor};
`;

export const ChunkItemBoldBodyText = styled(ChunkItemBodyText)`
    font-weight: 800;
`;

export const SelectionModalTitle = styled.span`
    font-family: ${userFontFamily};
    font-weight: 700;
    font-size: 16px;
    color: 'white';
`

export const SelectionModalDescription = styled.span`
    font-family: ${userFontFamily};
    font-weight: 700;
    font-size: 12px;
    color: 'white';
`

export const SelectionModalDescriptionBold = styled(SelectionModalDescription)`
    font-weight: 800;
`

export const ChunkItemMissingText = styled.span`
    font-family: ${dgTagFontFamily};
    font-weight: 500;
    font-size: 14px;
    font-style: italic;
    color: ${greyText};
`;

export const DocSetTitle = styled.span`
    font-family: ${userFontFamily};
    font-size: 26px;
    font-weight: 800;
    color: ${appContentColor};
`;

export const DocExplorerAddDocsSecondaryText = styled.span`
    font-family: ${dgFontFamily};
    font-size: 20px;
    font-weight: 300;
    color: ${appContentColor};
`;

export const SmallLabel = styled.span`
    font-family: ${userFontFamily};
    font-size: 18px;
    font-weight: 300;
    color: ${appContentColor};
`;

export const SmallBoldLabel = styled(SmallLabel)`
    font-weight: 900;
`;

export const DocExplorerNavigationItemLabel = styled.span`
    font-family: ${userFontFamily};
    font-size: 16px;
    font-weight: 400;
`;

export const DocExplorerInfoLabel = styled(SmallButton)`
    color: ${greyText};
`

export const ExplorerStatusItemLabel = styled.span`
    font-family: ${dgFontFamily};
    font-size: 14px;
    font-weight: 500;
`;

export const ExplorerStatusMessageLabel = styled(ExplorerStatusItemLabel)`
    font-size: 12px;
`

export const ExplorerStatusHeader = styled(ExplorerStatusItemLabel)`
    font-size: 10px;
`;

export const ScrollessContainer = css`
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* Chrome/Safari/Webkit */
    }
`;

export const ControlPanelActionButtonLabel = styled.span`
    font-family: ${dgFontFamily};
    font-size: 10px;
    font-weight: 500;
`;

export const DocSetChooserItemLabel = styled.span`
    font-family: ${userFontFamily};
    font-weight: 400;
    font-size: 14px;
`;

export const SmallHeaderLabel = styled.span`
    font-family: ${userFontFamily};
    font-weight: 500;
    font-size: 10px;
    text-transform: capitalize;
`;

export const ErrorPageTitleText = styled(UserTitle)`
    font-size: 90px;
    line-height: 90px;
    font-weight: 700;
    color: #D0CDCD;
`;

export const ErrorPageSubText = styled(UserTitle)`
    font-weight: 600;
`;
